TYPE_CONTENT_SERIES_LINK